import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { ExampleLines } from "../../flashcardUtils";
import PronunciationLine from "./PronunciationLine";

function LearnStage({ practiceCard, practiceMeta }) {
  return (
    <Grid container spacing={2.5} alignItems="stretch">
      <Grid item xs={12} md={5}>
        <Box
          sx={{
            height: "100%",
            minHeight: { xs: 230, md: 300 },
            p: { xs: 2.5, md: 2.5 },
            borderRadius: "20px",
            bgcolor: practiceMeta.surface,
            border: "1.5px dashed #d7eaf5",
            display: "grid",
            alignContent: "center",
            textAlign: "center",
          }}
        >
          <Typography sx={{ color: practiceMeta.accent, fontSize: 13, fontWeight: 800, textTransform: "uppercase", mb: 1 }}>
            Word
          </Typography>
          <Typography sx={{ color: "var(--toeic-ink-deep)", fontSize: { xs: 38, md: 48 }, fontWeight: 800, lineHeight: 1.04 }}>
            {practiceCard.front}
          </Typography>
          <PronunciationLine card={practiceCard} accent={practiceMeta.accent} />
        </Box>
      </Grid>
      <Grid item xs={12} md={7}>
        <Box className="lingualica-scrollarea" sx={{ maxHeight: { xs: "none", md: 300 }, overflowY: "auto", pr: { md: 1 } }}>
          <Typography sx={{ color: "var(--toeic-ink-soft)", fontSize: 13, fontWeight: 800, textTransform: "uppercase", mb: 0.75 }}>
            Meaning
          </Typography>
          <Typography sx={{ color: "var(--toeic-ink-deep)", fontSize: { xs: 24, md: 28 }, fontWeight: 800, lineHeight: 1.16 }}>
            {practiceCard.back}
          </Typography>
          {practiceCard.definition && practiceCard.definition !== practiceCard.back && (
            <Box sx={{ mt: 2, p: 1.5, borderRadius: "16px", bgcolor: "#f4fbff", border: "1px solid #d7eaf5" }}>
              <Typography sx={{ color: "var(--toeic-ink-soft)", fontSize: 12.5, fontWeight: 800, textTransform: "uppercase", mb: 0.5 }}>
                Definition
              </Typography>
              <Typography sx={{ color: "var(--toeic-ink)", fontSize: 15.5, fontWeight: 500, lineHeight: 1.5 }}>
                {practiceCard.definition}
              </Typography>
            </Box>
          )}
          {practiceCard.example && (
            <Box sx={{ mt: 2 }}>
              <Typography sx={{ color: "var(--toeic-ink-soft)", fontSize: 12.5, fontWeight: 800, textTransform: "uppercase", mb: 0.75 }}>
                Examples
              </Typography>
              <ExampleLines example={practiceCard.example} term={practiceCard.front} />
            </Box>
          )}
        </Box>
      </Grid>
    </Grid>
  );
}

export default LearnStage;
